import {FormArray} from '@angular/forms';
import {get, isArray, isObject, isString} from 'lodash';
import {TranslocoService} from '@jsverse/transloco';
import { HttpEventType, HttpHeaderResponse, HttpProgressEvent, HttpResponse, HttpSentEvent, HttpUserEvent } from '@angular/common/http';


export function keyPressNumbers(event) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode < 48 || charCode > 57)) {
        event.preventDefault();
        return false;
    } else {
        return true;
    }
}

export function clearFormArray(formArray: FormArray, emitEvent = false): void {
    while (formArray.length !== 0) {
        formArray.removeAt(0, {emitEvent: emitEvent});
    }
}

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function trimObjValues(obj): any {
    Object.keys(obj).forEach((key) => {
        if (isString(obj[key]) && !!obj[key]) {
            obj[key] = obj[key]?.trim();
        } else if (isObject(obj[key])) {
            trimObjValues(obj[key]);
        } else if (isArray(obj[key]) && obj[key].length > 0) {
            obj[key].forEach(elem => trimObjValues(elem));
        }
    });
}


export function removeUnderscore(value: string): string {
    return  isString(value) ? value?.replace(/_/g, ' ')?.trim() : value;
}

export const getTransalate = (_translocoService: TranslocoService, translate: string): string => {
    const activeLang = _translocoService.getActiveLang();
    const translation = _translocoService.getTranslation().get(activeLang);
    return get(translation, translate, translate);
}
export const progressBar = (value: HttpSentEvent | HttpHeaderResponse | HttpResponse<any> | HttpProgressEvent | HttpUserEvent<any>, uploadProgress$): void  =>{
    if (value.type === HttpEventType.UploadProgress) {
        uploadProgress$.next(Math.round(100 * (value.loaded / value.total)) - 5);
    }
}

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function readUserIdByParseJwtToken(token: string | null | undefined) {
    if(!!token){
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return  JSON.parse(jsonPayload).sub;
    }
}

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function formatDateFile(date: Date | string): string {
    const d = new Date(date);
    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}-${pad(d.getHours())}${pad(d.getMinutes())}`;
}
